import { toast as sonnerToast } from "sonner";

const toast = {
  success: (msg) => sonnerToast.success(msg),
  error: (msg) => sonnerToast.error(msg),
  loading: (msg) => sonnerToast.loading(msg),
  info: (msg) => sonnerToast.info(msg),
  warning: (msg) => sonnerToast.warning(msg),
  dismiss: (id) => sonnerToast.dismiss(id),
};

export { toast };
export default toast;
